enum Apps {
  Homescapes = 'homescapes',
  Township = 'township',
}

export { Apps };
